import { Update } from '@ngrx/entity';
import { createAction, props } from '@ngrx/store';
import { CalcType } from '../../../lookups/CalcType';
import { IndirectRateStructure } from './indirect-rate-structure.model';

export const loadIndirectRateStructures = createAction(
    '[IndirectRateStructure/API] Load IndirectRateStructures',
    props<{ indirectRateStructures: IndirectRateStructure[] }>()
);

export const addIndirectRateStructure = createAction(
    '[IndirectRateStructure/API] Add IndirectRateStructure',
    props<{ indirectRateStructure: IndirectRateStructure }>()
);

export const upsertIndirectRateStructure = createAction(
    '[IndirectRateStructure/API] Upsert IndirectRateStructure',
    props<{ indirectRateStructure: IndirectRateStructure }>()
);

export const addIndirectRateStructures = createAction(
    '[IndirectRateStructure/API] Add IndirectRateStructures',
    props<{ indirectRateStructures: IndirectRateStructure[] }>()
);

export const upsertIndirectRateStructures = createAction(
    '[IndirectRateStructure/API] Upsert IndirectRateStructures',
    props<{ indirectRateStructures: IndirectRateStructure[] }>()
);

export const updateIndirectRateStructure = createAction(
    '[IndirectRateStructure/API] Update IndirectRateStructure',
    props<{ indirectRateStructure: Update<IndirectRateStructure> }>()
);

export const updateIndirectRateStructures = createAction(
    '[IndirectRateStructure/API] Update IndirectRateStructures',
    props<{ indirectRateStructures: Update<IndirectRateStructure>[] }>()
);

export const deleteIndirectRateStructure = createAction(
    '[IndirectRateStructure/API] Delete IndirectRateStructure',
    props<{ id: string }>()
);

export const deleteIndirectRateStructures = createAction(
    '[IndirectRateStructure/API] Delete IndirectRateStructures',
    props<{ ids: string[] }>()
);

export const clearIndirectRateStructures = createAction(
    '[IndirectRateStructure/API] Clear IndirectRateStructures'
);

export const getIndirectRateStructures = createAction(
    '[IndirectRateStructure/API] Get IndirectRateStructures',
    props<{ FiscalYear?: string; Ratetype?: string }>()
);
export const getIndirectRateTypes = createAction(
    '[IndirectRateType/API] Get IndirectRateTypes'
);
export const loadIndirectRateTypes = createAction(
    '[IndirectRateType/API] Load IndirectRateTypes',
    props<{ indirectRateTypes: CalcType[] }>()
);
export const putIndirectRateStructures = createAction(
    '[IndirectRateStructure/API] Put IndirectRateStructure',
    props<{ indirectRateStructures: IndirectRateStructure[] }>()
);
export const removeIndirectRateStructures = createAction(
    '[IndirectRateStructure/API] Remove IndirectRateStructure',
    props<{ indirectRateStructures: IndirectRateStructure[] }>()
);
